module.exports = __webpack_public_path__ + "img/public/AdminIcons/manageAdmin.svg?f8df59f6";